export const productCenterContent = {
  titleCn: '产品中心',
  titleEn: 'PRODUCT CENTER',
  items: [
    {
      slug: 'intro',
      icon: 'ri-apps-2-line',
      titleCn: '产品介绍',
      titleEn: 'Product Introduction',
      desc: '析莜科技全系产品与解决方案一体化概览',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%20overview%20of%20interconnected%20technology%20solutions%2C%20clean%20geometric%20network%20of%20nodes%20representing%20multiple%20products%20working%20together%20in%20a%20unified%20system%2C%20deep%20charcoal%20background%20with%20subtle%20warm%20amber%20and%20cool%20blue%20accent%20edges%2C%20modern%20corporate%20technology%20aesthetic%2C%20restrained%20and%20elegant%2C%20no%20glowing%20particles%2C%20no%20neon%20lights%2C%20professional%20enterprise%20solution%20visualization&width=800&height=500&seq=pc-intro-01&orientation=landscape',
      intro:
        '析莜科技围绕企业数字化转型与资金安全，构建了覆盖AI智能化、业务管理、网银盾智能管理与安全硬件的一体化产品体系。从NLP自然语言处理、OCR光学字符识别、RPA流程自动化等AI核心能力，到网银业务智管平台、网银盾智管平台，再到自主研发的CloudUSB系列网银U盾服务器，为央国企与大型企业提供安全、高效、可视、可控的完整解决方案。',
      features: [
        {
          icon: 'ri-brain-line',
          title: 'AI人工智能',
          desc: 'NLP自然语言处理、OCR光学字符识别与RPA流程自动化，赋能企业流程智能化升级。',
        },
        {
          icon: 'ri-building-4-line',
          title: '网银业务智管平台',
          desc: '覆盖ERP、CRM、供应链的一体化业务管理解决方案，实现资金安全可视可控。',
        },
        {
          icon: 'ri-bank-line',
          title: '网银盾智管平台',
          desc: '网银U盾智能管理与安全认证一体化平台，AI识别与国密加密保障资金安全。',
        },
        {
          icon: 'ri-usb-line',
          title: '网银U盾服务器',
          desc: '自主研发的安全认证硬件设备，通过CCC认证与等保三级安全测评。',
        },
      ],
    },
    {
      slug: 'fund-platform',
      icon: 'ri-building-4-line',
      titleCn: '网银业务智管平台',
      titleEn: 'Online Banking Fund Platform',
      desc: 'ERP、CRM、供应链管理等一体化业务管理解决方案',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%20financial%20data%20visualization%20concept%2C%20clean%20geometric%20dashboard%20with%20flowing%20fund%20data%20lines%2C%20deep%20charcoal%20background%20with%20subtle%20warm%20amber%20and%20cool%20blue%20accents%2C%20modern%20corporate%20fintech%20aesthetic%2C%20restrained%20and%20professional%2C%20no%20glowing%20neon%2C%20elegant%20treasury%20management%20visual&width=800&height=500&seq=pc-fund-01&orientation=landscape',
      intro:
        '网银业务智管平台面向集团企业与央国企，提供覆盖ERP、CRM、供应链管理等环节的一体化业务管理解决方案。平台以资金可视化为核心，打通银企直连、账户管理、资金归集与支付审批全流程，助力企业构建统一的智能一体化体系，实现资金安全、高效、可视、可控。',
      features: [
        {
          icon: 'ri-funds-line',
          title: '资金可视化',
          desc: '多账户、多银行资金统一视图，实时掌握集团资金全貌与头寸分布。',
        },
        {
          icon: 'ri-bank-card-line',
          title: '智能一体化',
          desc: '资金归集、统筹调度与预算管控一体化，提升资金使用效率。',
        },
        {
          icon: 'ri-exchange-line',
          title: '银企对账',
          desc: '自动对接银行流水，智能匹配业务单据，大幅降低对账工作量与差错率。',
        },
        {
          icon: 'ri-check-double-line',
          title: '网银支付审批',
          desc: '覆盖制单、复核、审核的支付权限闭环，保障资金支付安全合规。',
        },
      ],
    },
    {
      slug: 'shield-platform',
      icon: 'ri-bank-line',
      titleCn: '网银盾智管平台',
      titleEn: 'Online Banking Shield Platform',
      desc: '网银U盾智能管理、资金可视化、AI识别与安全认证一体化平台',
      image: 'https://readdy.ai/api/search-image?query=Minimal%20abstract%20digital%20security%20concept%2C%20clean%20geometric%20shield%20shape%20with%20subtle%20lock%20and%20key%20detail%2C%20deep%20charcoal%20background%20with%20muted%20blue%20gray%20tones%2C%20modern%20corporate%20cybersecurity%20aesthetic%2C%20restrained%20and%20elegant%2C%20no%20glowing%20effects%2C%20professional%20online%20banking%20security%20visual&width=800&height=500&seq=pc-shield-01&orientation=landscape',
      intro:
        '网银盾智管平台是网银U盾智能化管理与安全认证一体化平台，结合AI识别、生物识别与国密加密等技术，实现U盾的批量管理、按需调用与安全认证。平台还原并提升第二代U盾的安全机制，让财务人员无需反复切换软件即可高效、安全地使用U盾完成资金操作。',
      features: [
        {
          icon: 'ri-key-2-line',
          title: 'U盾智能管理',
          desc: '批量管理制单、审核等支付权限U盾，统一调度、按需连接。',
        },
        {
          icon: 'ri-fingerprint-line',
          title: 'AI识别与生物认证',
          desc: '基于指纹身份识别验证身份，还原第二代U盾安全机制，防止越权使用。',
        },
        {
          icon: 'ri-shield-keyhole-line',
          title: '安全认证',
          desc: 'SM2/SM3/SM4国密加密算法，https加密传输，零信任单次有效Token机制。',
        },
        {
          icon: 'ri-eye-line',
          title: '资金安全可视化',
          desc: 'U盾使用全流程可追溯、可监控，资金安全状态一目了然。',
        },
      ],
    },
    {
      slug: 'cloudusb-server',
      icon: 'ri-usb-line',
      titleCn: '网银U盾服务器',
      titleEn: 'CloudUSB Server',
      desc: '24/45端口机柜型与桌面型，安全认证硬件设备',
      image: 'https://readdy.ai/api/search-image?query=Professional%20product%20photography%20of%20black%20server%20hardware%20device%20with%20multiple%20USB%20ports%2C%20rack-mount%20industrial%20design%2C%20dark%20matte%20metal%20finish%2C%20minimal%20clean%20dark%20studio%20background%2C%20soft%20directional%20lighting%2C%20no%20glowing%20effects%2C%20corporate%20hardware%20product%20shot&width=800&height=500&seq=pc-server-01&orientation=landscape',
      intro:
        'CloudUSB系列网银U盾服务器是析莜自主研发的硬件设备，提供24/45端口机柜型与桌面型多种规格。产品基于发明专利技术的集成式模块化架构，本行业率先通过CCC认证，并率先通过等保三级机房接入标准的安全测评，广泛应用于央国企财务共享中心与业务管理中心。',
      features: [
        {
          icon: 'ri-award-line',
          title: 'CCC质量认证',
          desc: '本行业率先通过中国质量认证中心CCC认证，支持CQC官方查验。',
        },
        {
          icon: 'ri-shield-check-line',
          title: '等保三级安全测评',
          desc: '率先通过等保三级机房接入标准的安全测评，满足央国企内网安全要求。',
        },
        {
          icon: 'ri-layout-grid-line',
          title: '集成式模块化架构',
          desc: '基于发明专利技术的模块化设计，装卸U盾更方便，稳定可靠、易维护。',
        },
        {
          icon: 'ri-flashlight-line',
          title: '双向安全保护',
          desc: '15KV防静电、过压过流与持续短路保护，U盾与设备双向安全。',
        },
      ],
    },
  ],
};